import { Button, FormControl, FormHelperText, FormLabel, Icon, Select, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { Regulation } from "../../../../autogen/bff-api";
import { SUPPORTED_REGULATIONS } from "../../../../common/procurement/publicProcurementOptions";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";

interface FormValues {
  defaultRegulation: Regulation | "";
}

interface Props {
  currentValue: Regulation | null;
}

export const ChangeDefaultRegulation = ({ currentValue }: Props) => {
  const { saveOrganization, isSaving } = useSaveOrganization();
  const toast = useToast();
  const { t } = useTranslation();
  const displayer = useApiError();
  const { register, handleSubmit, watch } = useForm<FormValues>({
    defaultValues: { defaultRegulation: currentValue ?? "" },
  });

  const selected = watch("defaultRegulation");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ defaultRegulation: { value: values.defaultRegulation || null } });
      toast({ title: t("Default regulation has been updated!"), status: "success" });
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <FormControl id="defaultRegulation" mt="20px">
        <FormLabel>{t("Default regulation")}</FormLabel>
        <Select placeholder={t("Select the regulation you procure under most often") ?? ""} {...register("defaultRegulation")}>
          {SUPPORTED_REGULATIONS.map((regulation) => (
            <option key={regulation} value={regulation}>
              {t(regulation)}
            </option>
          ))}
        </Select>
        <FormHelperText>
          {t(
            "New procurements start on this regulation. Which one governs follows from what the individual procurement serves, so it can be overridden per procurement",
          )}
        </FormHelperText>
      </FormControl>
      {(currentValue ?? "") !== selected && (
        <Button
          mt="10px"
          leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
          variant="solid"
          colorScheme="teal"
          size="sm"
          type="submit"
          isLoading={isSaving}
        >
          {t("Save change")}
        </Button>
      )}
    </form>
  );
};
